"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoJsonLd = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _jsonld = require("./jsonld");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * Specify the image Google Search uses for your organization's logo in Search
 * results and in the Knowledge Graph.
 *
 * @remarks
 *
 * Google Search uses the markup in the use case example to recognize the image
 * to use as the organization’s logo. This ensures that, when possible, the
 * image appears in search results about the company. Markup like this is a
 * strong signal to Google Search algorithms to show this image in Knowledge
 * Graph displays.
 *
 * ```jsx
 * import React from 'react';
 * import { LogoJsonLd } from 'gatsby-plugin-next-seo';
 *
 * export default () => (
 *   <>
 *     <h1>Logo JSON-LD</h1>
 *     <LogoJsonLd logo='http://www.your-site.com/images/logo.jpg' url='http://www.your-site.com' />
 *   </>
 * );
 * ```
 */
var LogoJsonLd = function LogoJsonLd(_ref) {
  var url = _ref.url,
      logo = _ref.logo,
      _ref$overrides = _ref.overrides,
      overrides = _ref$overrides === void 0 ? {} : _ref$overrides,
      _ref$defer = _ref.defer,
      defer = _ref$defer === void 0 ? false : _ref$defer;

  var json = _objectSpread({
    '@context': 'https://schema.org',
    '@type': 'Organization',
    url: url,
    logo: logo
  }, overrides);

  return _react["default"].createElement(_jsonld.JsonLd, {
    defer: defer,
    json: json
  });
};

exports.LogoJsonLd = LogoJsonLd;